import { render } from "./BottomBarMobile.vue?vue&type=template&id=2d1741c1&scoped=true"
import script from "./BottomBarMobile.vue?vue&type=script&lang=js"
export * from "./BottomBarMobile.vue?vue&type=script&lang=js"

import "./BottomBarMobile.vue?vue&type=style&index=0&id=2d1741c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1741c1"]])

export default __exports__